import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

import HtmlWrapper from '../html-wrapper/html-wrapper';

import { IMunicipalitySearchWrapper } from './municipality-search';

const MunicipalitySearchWrapper = React.lazy(() => import('./municipality-search'));

export interface IDynamicMunicipalitySearch extends IMunicipalitySearchWrapper {
  children?: React.ReactNode;
}

export const MUNICIPALITY_SEARCH_TAG = 'ld-municipality-search-widget';

const DynamicMunicipalitySearch: React.FC<IDynamicMunicipalitySearch> = ({ url, children, mocked = false }) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MunicipalitySearchWrapper url={url} mocked={mocked} />
  </Suspense>
);

DynamicMunicipalitySearch.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

DynamicMunicipalitySearch.defaultProps = {
  children: null,
};

export default DynamicMunicipalitySearch;
